/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_R2_EndpointInputs */

const en_admin_settings_fields_r2_endpoint = /** @type {(inputs: Admin_Settings_Fields_R2_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint`)
};

/**
* | output |
* | --- |
* | "Endpoint" |
*
* @param {Admin_Settings_Fields_R2_EndpointInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_r2_endpoint = /** @type {((inputs?: Admin_Settings_Fields_R2_EndpointInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_R2_EndpointInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_r2_endpoint(inputs)
});
export { admin_settings_fields_r2_endpoint as "admin.settings.fields.r2_endpoint" }